import { all, select, call, takeEvery, put } from 'redux-saga/effects';
import { isEmpty } from 'lodash';

import apiSaga from './apiSaga';
import {
  GET_AUTH_PROVIDER_URL,
  GET_AUTH_PROVIDER_DETAILS,
  SEND_EXTERNAL_AUTH_TOKEN,
} from 'actionTypes';
import {
  getAuthProviderUrl,
  getAuthProviderUrlSuccess,
  getAuthProviderUrlFailure,
  sendExternalAuthTokenSuccess,
} from 'actions';

/* There are some different complex flows, here's a rough outline:

- Get all auth urls
  - Checks which of the given providers needs to be refetched
  - Emits an action for each of them

- Get auth url
  - If unsuccessful, reducer marks them as unfetchable
  - If successful, reducer stores the url and still marks them as unfetchable

- Send Auth Provider token
  - Auth Provider URL reducer removes the url (since the token is now invalid)
  - If successful, user gets logged in
  - If unsuccessful, another GET_AUTH_PROVIDER_URL action is queued up

*/

const authProviderDetailsSaga = function*(action) {
  const { providers } = action;
  const state = yield select();

  const providersToFetch = providers.filter(provider => {
    const details = state.authProviderUrls[provider];
    // If theres no details, or the details indicate we should fetch
    return !details || details.shouldFetch;
  });

  yield all(
    providersToFetch.map(provider => put(getAuthProviderUrl(provider)))
  );
};

const authProviderUrlSaga = function*(action) {
  let response = yield call(apiSaga, action, action.payload);

  if (isEmpty(response.errors)) {
    yield put(getAuthProviderUrlSuccess(action.provider, response));
  } else {
    yield put(getAuthProviderUrlFailure(action.provider, response));
  }
};

const sendExternalAuthTokenSaga = function*(action) {
  let response = yield call(apiSaga, action, action.payload);

  if (isEmpty(response.errors)) {
    yield put(sendExternalAuthTokenSuccess(response));
  } else {
    yield put(getAuthProviderUrl(action.provider));
  }
};

export default [
  takeEvery(GET_AUTH_PROVIDER_DETAILS, authProviderDetailsSaga),
  takeEvery(GET_AUTH_PROVIDER_URL, authProviderUrlSaga),
  takeEvery(SEND_EXTERNAL_AUTH_TOKEN, sendExternalAuthTokenSaga),
];



// WEBPACK FOOTER //
// ./src/sagas/oauthSagas.js